import { Component, OnInit, Renderer2 } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import timeGridPlugin from '@fullcalendar/timegrid';
import { TourService } from 'ngx-tour-ngx-bootstrap';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [DatePipe]
})
export class HeaderComponent implements OnInit {
  loagActivityData: any = null;
  activityData: any;
  newchallenge = false;
  logActivity: Boolean = false;
  logManually: Boolean = false;
  postoutcomes = [];
  myDate;
  createGoal: Boolean = false;
  createOutcome: Boolean = false;
  isDisabled: any = true;
  notifications: Array<any> = [];
  suggestions: Array<any> = [];
  searchData = [
    { id: 0, text: 'Dashboard', route: '/dashboard' },
    { id: 1, text: 'Home', route: '/dashboard' },
    { id: 2, text: 'Categories', route: '/categories' },
    { id: 3, text: 'Roadmap', route: '/roadmap' },
    { id: 4, text: 'Neighbourhoods and groups', route: '/groups' },
    { id: 5, text: 'Groups', route: '/groups' },
    { id: 6, text: 'Communities', route: '/groups' },
    { id: 7, text: 'Challenges', route: '/challenges' },
    { id: 8, text: 'Created challenge', route: '/challenges' },
    { id: 9, text: 'Recieved challenge', route: '/challenges' },
    { id: 10, text: 'Archived challenge', route: '/challenges' },
    { id: 11, text: 'Public challenge', route: '/challenges' },
    { id: 12, text: 'Create new challenge', route: '/challenges-new' },
    { id: 13, text: 'New challenge', route: '/challenges-new' },
    { id: 14, text: 'Settings', route: '/profile' },
    { id: 15, text: 'Profile', route: '/profile' },
    { id: 16, text: 'Notifications', route: '/notifications' },
    { id: 17, text: 'Suggestions', route: '/suggestions' },
    { id: 17, text: 'My Logged Activities', route: '/activities' },
  ]
  constructor(
    public tourService: TourService,
    private datePipe: DatePipe,
    private renderer: Renderer2,
    public translations: TranslationService,
    private route: ActivatedRoute,
    private apiservice: ApiService,
    private router: Router
  ) {
    this.myDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.tourService.initialize([{
      stepId: '1',
      anchorId: 'dashboard-icon',
      title: 'Dashboard',
      content: 'The Dashboard monitors your progress',
      placement: 'bottom',
      containerClass: 'lunge-tour',
    }, {
      stepId: '2',
      anchorId: 'get-started',
      title: 'Get Started',
      content: 'The Priority Areas are the 3 major goals. Within each major goal you can add your own goals.',
      placement: 'bottom',
      containerClass: 'lunge-tour',
    }, {
      stepId: '3',
      anchorId: 'action-list',
      title: 'Action Lists',
      content: 'Each of the Priority Areas (major goals) have actions steps. Click on each action to log your time.',
      placement: 'bottom',
      containerClass: 'lunge-tour'
    }, {
      stepId: '4',
      anchorId: 'challenges-list',
      title: 'Challenges',
      content: 'To create your own Challenge. 1-> Click upper left “Create a new challenge”. 2-> Choose Category, Choose Activity, Choose Goal, Choose Outcome, Select Start Date,Select End Date, Write description of challenge. 3-> Click Create Challenge. 4-> Invite participants, Click Invite Participants.  5-> Click “Challenge page”.',
      placement: 'top',
      containerClass: 'lunge-tour'
    },
    {
      stepId: '5',
      anchorId: 'light-bulb',
      title: 'Suggestions',
      content: 'Suggestions based on the actions of other users',
      placement: 'left',
      containerClass: 'lunge-tour'
    }]);
  }

  ngOnInit() {
    this.apiservice.getClient().subscribe((res: any) => {
      this.newchallenge = res.data.challenegestatus;
    });
    if (this.apiservice.user.profiles) {
      this.apiservice.updateUserGoals({ profile: this.apiservice.user.profiles, user: this.apiservice.user._id }).subscribe((res) => {

      })
    }
    this.apiservice.notificationSubject.subscribe(() => {
      this.getNotifications();
    });
    this.apiservice.suggestionSubject.subscribe(() => {
      this.getSuggestions();
    });
    this.getNotifications();
    this.getSuggestions();
  }


  getNotifications() {
    this.apiservice.getAllN(this.apiservice.user._id).subscribe((res: any) => {
      this.notifications = res.data;
    });
  }

  markAllAsRead() {
    this.apiservice.markAsReadN(this.apiservice.user._id).subscribe((res: any) => {
      this.apiservice.notificationSubject.next();
    });
  }

  selectEvent(item) {
    this.router.navigate([item.route]);
  }

  getSuggestions() {
    this.apiservice.getAllS(this.apiservice.user._id).subscribe((res: any) => {
      this.suggestions = res.data;
    });
  }

  markAllAsReadS() {
    this.apiservice.markAsReadS(this.apiservice.user._id).subscribe((res: any) => {
      this.apiservice.suggestionSubject.next();
    });
  }

  checkForActive() {
    let active = this.notifications.filter(not => not.read == false);
    if (active.length > 0) {
      return true
    }
    return false;
  }

  checkForActiveS() {
    let active = this.suggestions.filter(not => not.read == false);
    if (active.length > 0) {
      return true
    }
    return false;
  }

  todayCommitments = [timeGridPlugin];

  formatTime(date) {
    return moment(date).format('MMM DD, YYYY hh:mm A');
  }

  closeTour() {
    this.tourService.end();
    this.renderer.removeClass(document.body, 'overlay');
  }

  showSidebar() {
    this.renderer.removeClass(document.body, 'sidebar-hidden');
  }
  showSidebarMobile() {
    this.renderer.addClass(document.body, 'sidebar-show');
    setTimeout(() => {
      this.apiservice.setSidebar();
    }, 200);

  }

  openManualForm(event) {
    this.activityData = event.activityData;
    this.postoutcomes = event.postoutcomes;
    this.logManually = true;
  }

  routeName() {
    return this.route.snapshot.data['name'];
  }

  openActivities() {
    this.router.navigate(['/activities']);
  }

}
